import type {SagaIterator} from 'redux-saga';
import {call} from 'redux-saga/effects';

/**
 * Resolve context.
 *
 * @param {string} type - Context type.
 * @param {any} data - Context data.
 * @returns {SagaIterator} - Dynamic Yield context.
 */
export function* createContext(type: string, data: any = null): SagaIterator {
    const context = {type};

    if (data) return yield call([Object, 'assign'], context, {data});

    return context;
}
